import * as actionTypes from "./actionTypes";

export const setSelectedStok = (stok) => ({
  type: actionTypes.SET_SELECTED_STOK,
  payload: stok,
});
